
import { Component, Mixins } from "vue-property-decorator";
import OfficeInformationEdit from "./components/steps/office-information-edit.vue";
import OfficeStaffEdit from "./components/steps/office-staff-edit.vue";
import OfficeHoursEdit from "./components/steps/office-hours-edit.vue";
import OfficeRatesEdit from "./components/steps/office-rates-edit.vue";
import OfficePayrollEdit from "./components/steps/office-payroll-edit.vue";
import OfficeSubscriptionEdit from "./components/steps/office-subscription-edit.vue";
import OfficeProfilesMixin from "./office-profiles.mixin";
import { mapState } from "vuex";
import AuthMixin from "@/common/mixins/auth.mixin";

@Component({
  components: {
    OfficeInformationEdit,
    OfficeStaffEdit,
    OfficeHoursEdit,
    OfficeRatesEdit,
    OfficePayrollEdit,
    OfficeSubscriptionEdit
  },
  computed: {
    ...mapState("OfficeProfile", ["selectedOffice"])
  }
})

export default class OfficeProfilesEditComponent extends Mixins(OfficeProfilesMixin, AuthMixin) {
  activeTab = 0;

  async created(): Promise<void> {
    this.$store.dispatch("OfficeProfile/resetForm");
  
    await this.$store.dispatch("OfficeProfile/getOfficeUserData");

    if (this.isEdit){
      this.activeTab = parseInt(this.$route.query.activeTab as string) ?? 0;
    }
  }

  backToList(): void {
    this.$router.push("/office-profiles");
  }

  isActive(tab: number): boolean {
    return (this.isEdit && tab == 0) || 
      (!this.isEdit && this.activeTab != tab);
  }

  isDisabled(tab: number): boolean {
    return !this.isEdit && this.activeTab != tab;
  }
}
